module.exports = __webpack_public_path__ + "img/photo-03.5e19d164.jpg";